"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extend = void 0;

var extend = function extend(plugins, options, module) {
  if (Array.isArray(plugins)) {
    plugins.forEach(function (plugin) {
      if (typeof plugin === 'function') plugin(options, module);
    });
  }

  return module;
};

exports.extend = extend;